import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../contexts/LanguageContext';

// Wraps the (per-modal) placeholders list content in a header + toggle. On desktop the toggle
// is hidden and the body is always shown, unchanged from before. On mobile the body starts
// collapsed - this list can be long, and previously it always claimed a fixed chunk of the
// (already tight) vertical space above the editor; now it only takes what a single header row
// needs until the user actually wants it.
const PlaceholdersSidebar = ({ description, children }) => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  // Placeholder buttons are rendered by each caller, not this component - rather than plumbing
  // a "close after insert" callback through every list item in three different files, catch the
  // click here via delegation once it bubbles up. No-op visually on desktop, where the body is
  // always shown regardless of isOpen.
  const handleBodyClick = (e) => {
    if (e.target.closest('.placeholder-button')) {
      setIsOpen(false);
    }
  };

  return (
    <div className={`placeholders-sidebar${isOpen ? ' is-open' : ''}`}>
      <button
        type="button"
        className="placeholders-sidebar-toggle"
        onClick={() => setIsOpen((open) => !open)}
        aria-expanded={isOpen}
      >
        <FontAwesomeIcon icon={faBars} />
        <span>{t('settings.availablePlaceholders')}</span>
        <FontAwesomeIcon icon={faChevronDown} className="placeholders-sidebar-chevron" />
      </button>
      <div className="placeholders-sidebar-body" onClick={handleBodyClick}>
        <h4 className="placeholders-sidebar-title">{t('settings.availablePlaceholders')}</h4>
        <p className="placeholder-description">{description}</p>
        {children}
      </div>
    </div>
  );
};

export default PlaceholdersSidebar;
